import { AllergenDto } from './allergen.dto';
import { CartProductModifierGroupDto } from './cartProductModifierGroup.dto';
import { ModifierDto } from './modifier.dto';

export interface CartProductModifierDto {
  id: string;
  modifierName: string;
  price: number;
  selected: boolean;
  cartProductModifierGroupId?: number;
  cartProductModifierGroup?: CartProductModifierGroupDto;
  modifierId: number;
  modifier?: ModifierDto;
  isMultiSelect?: boolean;
  selectedValue?: number;
  modifierGroupId?: number; // UP-4100 - required for orderItemModifier reorder
  isCoveredByLoyaltyPoints?: boolean;
  quantityCoveredByLoyalty?: number;
  clickedSequence?: number;
  allergens?: AllergenDto[];
  colorCode?: string;
}
